import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { ErrorToast } from '../../../components';

import {
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints
} from '../../../slices/auth-slice';
import { RootState } from '../../../app/store';
import { setUserToLS } from '../../../helpers/localstorage-helper';
import {
  checkEarnBetUserAsync,
  transferToEarnBetAsync
} from './Transfer.requests';
import { EarnBetTransfer, TransferSteps } from './Transfer.types';
import { PurchaseEarnBetSteps } from '../../EarnBet/EarnBet.types';

export const transferToEarnBet = createAsyncThunk(
  'transferToEarnBet',
  async (
    {
      cash,
      usdt,
      usdc,
      networkType,
      isEarnBetTransfer,
      setTransferStep
    }: {
      cash: number;
      usdt: number;
      usdc: number;
      networkType: number | null;
      isEarnBetTransfer: EarnBetTransfer;
      setTransferStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await transferToEarnBetAsync({
        cash,
        usdt,
        usdc,
        networkType
      });

      const state = getState() as RootState;

      if (isEarnBetTransfer === EarnBetTransfer.isEarnBetTransfer) {
        setTransferStep(PurchaseEarnBetSteps.ORDER_CONFIRMATION);
      } else {
        setTransferStep(TransferSteps.TRANSFER_SUCCESS);
      }

      const user = {
        ...state.auth.userInfo,
        user: {
          ...state.auth.userInfo.user,
          userTickets: {
            ...state.auth.userInfo.user.userTickets,
            shoppingPoints: data.userTickets.shoppingPoints,
            availableRewardPoints: data.userTickets.availableRewardPoints
          }
        }
      };

      setUserToLS(user);

      dispatch(
        changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
      );

      dispatch(changeAvailableShoppingPoints(data!.userTickets.shoppingPoints));

      return {
        userTickets: data.userTickets,
        userEarnbetTopup: data.userEarnbetTopup,
        isEarnBetTransfer:
          isEarnBetTransfer === EarnBetTransfer.isEarnBetTransfer
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const checkEarnBetUser = createAsyncThunk(
  'checkEarnBetUser',
  async () => {
    const { data } = await checkEarnBetUserAsync();

    return data;
  }
);
